// ***************************************
// Definition of game token ExplosionParticle
// ***************************************
import { tbEase } from "../engine/tbEase";
import { tbGame } from "../engine/tbGame";
import { tbParticle } from "../engine/tbParticle";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { s_sparkle_particle } from "./AssetDefinitions/ImageDefinitions";
import { s_sparkle_trail } from "./AssetDefinitions/JsonDefinitions";
import { getContainerForLayer, Layer } from "./SceneController";
// The constructor for the ExplosionParticle game token. 
export var ExplosionParticle = function (x, y, container) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    // Your own properties
    this.x = x;
    this.y = y;
    this.startPos = [];
    this.destination = [];
    this.container = getContainerForLayer(Layer.particle);
    this.particle = [];
    this.amountOfParticles = 4;
    this.duration = 14000;
    this.time = 0;
    this.startMove = false;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
ExplosionParticle.prototype.handleAdd = function () {
    "use strict";
    var self = this, scale = (1 / PhysicsSettings.textureResolution), effectScale = scale;
    for (var i = 0; i < this.amountOfParticles; i++) {
        var particle = new tbParticle(this.container, s_sparkle_trail, [s_sparkle_particle], true);
        particle.setScale(effectScale);
        particle.setPosition(this.x, this.y);
        var vecDestination = this.findDestination(this.x, this.y, Math.round(Math.random() * 360), 25);
        this.startPos.push({ x: this.x, y: this.y });
        this.destination.push(vecDestination);
        particle.show();
        this.particle.push(particle);
    }
    this.startMove = true;
};
ExplosionParticle.prototype.findDestination = function (xCoord, yCoord, angle, length) {
    "use strict";
    length = typeof length !== 'undefined' ? length : 10;
    //angle = angle * Math.PI / 180; // if you're using degrees instead of radians
    return {
        x: length * Math.cos(angle) + xCoord,
        y: length * Math.sin(angle) + yCoord
    };
};
// handleRemove is called when the token is removed from the game.
ExplosionParticle.prototype.handleRemove = function () {
    "use strict";
    for (var i = 0; i < this.particle.length; i++) {
        this.particle[i].destroy();
    }
};
// handleBeginStep is called each step before processing other events.
ExplosionParticle.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    if (!this.startMove) {
        return;
    }
    this.time += timePassed;
    for (var i = 0; i < this.particle.length; i++) {
        this.particle[i].update(timePassed);
        var moveX = tbEase.easeLinear(this.time, this.startPos[i].x, this.startPos[i].x - this.destination[i].x, this.duration);
        var moveY = tbEase.easeLinear(this.time, this.startPos[i].y, this.startPos[i].y - this.destination[i].y, this.duration);
        //setMove
        this.particle[i].setMove(moveX, moveY);
        this.startPos[i].x = moveX;
        this.startPos[i].y = moveY;
    }
    if (this.time > this.duration) {
        this.startMove = false;
        tbGame.removeToken(this);
    }
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
ExplosionParticle.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
ExplosionParticle.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
ExplosionParticle.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
ExplosionParticle.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
ExplosionParticle.prototype.handleEndStep = function (timePassed) {
    "use strict";
};
// handleDraw is called at the end of a step to draw the token.
ExplosionParticle.prototype.handleDraw = function () {
    "use strict";
};
